module.exports = __webpack_public_path__ + "img/brand-shape-2.efdacbee.png";